export default [
	{
		path: '/orderInfo/versionUpdate',
		component: (resolve) => require(['../page.vue'], resolve),
		meta: {
			title: '版本更新',
			keepAlive: false,
		},
	},
]
